import { Capacitor } from "@capacitor/core";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonLabel,
  IonModal,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonSkeletonText,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter,
} from "@ionic/react";
import {
  arrowBack,
  arrowForward,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronBack,
  chevronDown,
  close,
  closeCircleOutline,
} from "ionicons/icons";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import _ from "underscore";
import SegmentUtils, { SegmentProductCategories } from "../../lib/SegmentUtils";
import StringUtils from "../../lib/StringUtils";
import NumberUtils from "../../lib/NumberUtils";
import Constants from "../../lib/Constants";
import MealOptionCardNoSelection from "../MealOptionCardNoSelection";
import MealDetailModalV2 from "../MealDetailModalV2";
import { moveMessagePortToContext } from "worker_threads";
import PubSub from "../../lib/PubSub";
import Event from "../../lib/Event";
import StorageUtils from "../../lib/StorageUtils";
import moment from "moment";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { StripeCheckoutForm } from "../../pages/web/checkout/Checkout/Checkout";
import API from "../../lib/API";
import { loadStripe } from "@stripe/stripe-js";
import LocationSearchInputV2 from "../Map/LocationSearchInputV2";
import MapUtils from "../../lib/MapUtils";
import DateUtils from "../../lib/DateUtils";
import { Geolocation } from "@capacitor/geolocation";

let PLNPlusUpsellModal: React.FC<{
  open: boolean;
  user: any;
  store: any;
  onSignupComplete: () => void;
  onSubmitting: () => void;
  onLocationChange?: (store: any) => void;
  setOpen: (open: boolean) => void;
  presentingElement?: any;
  lead?: any;
  mealInfoModalID?: string;
}> = ({
  open,
  setOpen,
  user,
  store,
  onSignupComplete,
  onLocationChange,
  onSubmitting,
  presentingElement,
  mealInfoModalID,
  lead,
}) => {
  const pageRef = useRef();
  const orderSummaryRef = useRef<HTMLIonModalElement>(null);

  const [showOrderSummary, setShowOrderSummary] = useState<boolean>(false);
  const [planOptions, setPlanOptions] = useState<any>([]);
  const [procurementTypes, setProcurementTypes] = useState<any>([]);
  const [activeProcurement, setActiveProcurement] = useState<any>(null);
  const [frequencyTypes, setFrequencyTypes] = useState<any>([]);
  const [activeFrequency, setActiveFrequency] = useState<any>(null);
  const [allMeals, setAllMeals] = useState<any>([]);
  const [coupon, setCoupon] = useState<any>(null);
  const [plan, setPlan] = useState<any>(null);
  const [selectedPlanCriteria, setSelectedPlanCriteria] = useState<any>(null);
  const [hasInitializedPlanSelection, setHasInitializedPlanSelection] =
    useState<boolean>(false);
  const [activePlanType, setActivePlanType] = useState<any>(
    "613bdb37164e9569b55f38d0",
  );
  const [referral, setReferral] = useState<any>(null);
  const [stripeCustomerID, setStripeCustomerID] = useState<any>(null);
  const [stripe, setStripe] = useState<any>(null);
  const [stripeOptions, setStripeOptions] = useState<any>(null);
  const [selectedMeals, setSelectedMeals] = useState<any>([]);
  const [fetchingStripe, setFetchingStripe] = useState<boolean>(false);
  const [checkoutSubmitTrigger, setCheckoutSubmitTrigger] =
    useState<number>(0);
  const [checkoutFooterState, setCheckoutFooterState] = useState<any>({
    canSubmit: false,
    submitting: false,
    requiresSubscriptionTerms: false,
    confirmSubscriptionTerms: false,
  });

  const [referralCode, setReferralCode] = useState<string>("");
  const [referralSubmitting, setReferralSubmitting] = useState<boolean>(false);
  const [referralError, setReferralError] = useState<string>("");
  const [couponCode, setCouponCode] = useState<string>("");
  const [couponSubmitting, setCouponSubmitting] = useState<boolean>(false);
  const [couponError, setCouponError] = useState<string>("");
  const [filterOption, setFilterOption] = useState<string>("all");
  const [loadingStores, setLoadingStores] = useState<boolean>(false);
  const [allStores, setAllStores] = useState<any[]>([]);
  const [filteredStores, setFilteredStores] = useState<any[]>([]);
  const [locationFormSubmitting, setLocationFormSubmitting] =
    useState<boolean>(false);
  const [locationFormError, setLocationFormError] = useState<string>("");
  const [location, setLocation] = useState<any>(null);
  const [deliveryLocation, setDeliveryLocation] = useState<any>(null);
  const [allDeliveryStores, setAllDeliveryStores] = useState<any[]>([]);

  const getStoreDistance = (coordinates: any, store: any) => {
    let distance: any = MapUtils.calculateDistanceInMiles(
      coordinates?.lat,
      coordinates?.lng,
      store?.location?.geographic?.lat,
      store?.location?.geographic?.lng,
    );

    distance = Math.round(distance * 100) / 100;

    return distance;
  };

  const [planTypes, setPlanTypes] = useState<any>([
    {
      _id: "613bdb37164e9569b55f38d0",
      name: "Lifestyle",
      description:
        "The foundation of our lifestyle plan is consuming whole foods that are perfectly portioned to help you crush your health goals.  You’ll love the way it feels to eat nutrient-rich, gluten-free meals.",
      calorieMin: 400,
      calorieMax: 500,
      Created: "2021-09-29T17:57:47.764Z",
      LastUpdated: "2021-09-29T17:57:47.764Z",
      groupCode: "L",
      _idString: "613bdb37164e9569b55f38d0",
    },
    {
      _id: "613bddd9970e86ceef4dd8fc",
      name: "Athlete",
      description:
        "Do you do more, lift more, or have a heartier appetite? We got you covered. Our Athlete meals are 1.5 times the size of a Lifestyle meal to provide even more fuel and recovery from high-intensity workouts.",
      calorieMin: 600,
      calorieMax: 800,
      Created: "2021-09-29T17:57:48.603Z",
      LastUpdated: "2021-09-29T17:57:48.603Z",
      groupCode: "A",
      _idString: "613bddd9970e86ceef4dd8fc",
    },
  ]);

  const [submitting, setSubmitting] = useState<boolean>(false);
  const [step, setStep] = useState<string>("location");
  const [deliveryAvailable, setDeliveryAvailable] = useState<boolean>(true);
  const [storeTerritories, setStoreTerritories] = useState<any[]>([]);
  const isSelectingLocation = step === "location";

  /**
   * Loads the plan options for the given store
   *
   * @param store
   */
  let loadPlanOptions = async (store: any) => {
    if (!store) {
      return;
    }

    let planOptions = store?.products?.mealPlans;

    if (!planOptions?.length) {
      return;
    }

    planOptions = _.filter(planOptions, (plan: any) => {
      return plan?.availableToNewClients;
    });

    let procurementTypes: any = [];

    let frequencyTypes: any = [];

    for (let i = 0; i < planOptions?.length; i++) {
      let plan = planOptions[i];
      const idx = i;

      if (!frequencyTypes.includes(plan?.frequency)) {
        frequencyTypes.push(plan?.frequency);
      }

      if (!_.findWhere(procurementTypes, { procurement: plan?.procurement })) {
        let procurement: any = {
          procurement: plan?.procurement,
        };

        switch (procurement.procurement) {
          case "pickup":
            procurement.name = "In-Store Pickup";
            procurement.displayOrder = 1;
            break;
          case "delivery":
            procurement.name = "Local Delivery";
            procurement.displayOrder = 2;
            break;
          case "shipping":
            procurement.name = "Shipping";
            procurement.displayOrder = 3;
            break;
          default:
            break;
        }

        procurementTypes.push(procurement);
      }
    }

    procurementTypes = _.sortBy(procurementTypes, "displayOrder");

    let activeProcurement = null;

    if (procurementTypes?.length) {
      activeProcurement = procurementTypes[0];
    }

    frequencyTypes = frequencyTypes.sort((a: any, b: any) => {
      return a - b;
    });

    setPlanOptions(planOptions);
    setProcurementTypes(procurementTypes);
    setActiveProcurement(activeProcurement);
    setFrequencyTypes(frequencyTypes);
    setActiveFrequency(
      frequencyTypes?.includes("weekly") ? "weekly" : frequencyTypes[0],
    );

    const planType = _.findWhere(planTypes, {
      _id: activePlanType,
    });

    console.log(planTypes, activePlanType);

    let allMeals = store?.menus?.meals[planType?._id]?.active?.meals;

    console.log(allMeals);

    setAllMeals(allMeals);

    const plans = getPlansForCategory(
      planType?._id,
      activeProcurement,
      activeFrequency,
      planOptions,
    );

    trackProductListViewed(planType, plans);
  };

  /**
   * Gets the price of a plan
   *
   * @param plan
   * @param byMeal
   * @param numeric
   * @returns
   */
  let getPrice = (plan: any, byMeal: any = true, numeric = false) => {
    if (!plan) {
      return null;
    }

    let cents = plan?.unitPrice + (plan?.deliveryFee ? plan?.deliveryFee : 0);

    if (byMeal) {
      cents = cents / plan?.quantity;
    }

    if (numeric) {
      return cents;
    }

    return StringUtils.centsToCurrency(cents);
  };

  /**
   * Gets the promotional price of a plan
   *
   * @param plan
   * @param coupon
   * @param byMeal
   * @returns
   */
  let getPromotionalPrice = (plan: any, coupon: any, byMeal = true) => {
    let price: any = null;

    if (coupon) {
      price = NumberUtils.getCouponPromotionalPrice(plan, coupon);

      if (referral && !byMeal) {
        let planClone = JSON.parse(JSON.stringify(plan));

        planClone.unitPrice = planClone.unitPrice - referral?.flatDiscount;

        price = NumberUtils.getCouponPromotionalPrice(planClone, referral);
      }
    } else {
      price = {
        planPrice: getPrice(plan, false, true),
        mealPrice: getPrice(plan, true, true),
      };

      if (referral && !byMeal) {
        price.planPrice = price.planPrice - referral?.flatDiscount;

        price.mealPrice = price.planPrice / plan?.quantity;
      }

      price.planPrice = StringUtils.centsToCurrency(price.planPrice);
      price.mealPrice = StringUtils.centsToCurrency(price.mealPrice);
    }

    if (byMeal) {
      return price.mealPrice;
    }

    return price.planPrice;
  };

  /**
   * Fires a segment event for product list viewed
   *
   * @param planType
   * @param plans
   */
  let trackProductListViewed = async (planType: any, plans: any) => {
    if (!planType || !plans?.length) {
      //console.log("HERE HERE", planType, plans);

      return;
    }

    SegmentUtils.track("Product List Viewed", {
      category: SegmentProductCategories.MEAL_PLANS,
      list_id: planType?._id + "_" + activeProcurement?.procurement,
      products: plans.map((plan: any, i: any) => {
        return {
          product_id: plan?._id,
          name: plan?.name,
          sku: plan?.code,
          category: planType?.name + " " + activeProcurement?.procurement,
          position: i + 1,
          price: getPrice(plan, false, true) / 100,
          brand: "Project LeanNation",
          quantity: plan?.quantity,
          procurement: activeProcurement?.procurement,
          frequency: activeFrequency,
          store_id: store?.googleMapsPlaceID ? store?.googleMapsPlaceID : "",
          category1: planType?.name,
          category2: plan?.procurement,
          category3: plan?.frequency,
        };
      }),
    });
  };

  /**
   * Gets the plans for a category
   *
   * @param categoryID
   * @param procurementType
   * @param frequency
   * @param planOptions
   * @returns
   */
  let getPlansForCategory = (
    categoryID: string,
    procurementType: any,
    frequency: any,
    planOptions: any,
  ) => {
    if (!categoryID || !planOptions?.length) {
      return [];
    }

    let plans = _.filter(planOptions, (plan: any) => {
      return (
        plan?.planType?._id == categoryID &&
        plan?.procurement == procurementType?.procurement &&
        plan?.frequency == frequency
      );
    });

    plans = _.sortBy(plans, "quantity");

    return plans;
  };

  let isPlanSelectable = (selectedPlan: any) => {
    if (!selectedPlan) {
      return false;
    }

    if (selectedPlan?.procurement != "delivery") {
      return true;
    }

    return !!deliveryLocation && deliveryAvailable;
  };

  let getPlanSelectionKey = (selectedPlan: any) => {
    if (!selectedPlan) {
      return null;
    }

    return [
      selectedPlan?.planType?._id,
      selectedPlan?.quantity,
      selectedPlan?.frequency,
      selectedPlan?.procurement,
    ].join("|");
  };

  let getDefaultSelectablePlan = (plans: any[]) => {
    if (!plans?.length) {
      return null;
    }

    const selectablePlans = plans.filter((candidatePlan: any) =>
      isPlanSelectable(candidatePlan),
    );

    if (!selectablePlans?.length) {
      return null;
    }

    return (
      _.find(selectablePlans, (candidatePlan: any) => {
        return (
          candidatePlan?.quantity == 12 &&
          candidatePlan?.planType?.name?.toLowerCase()?.includes("lifestyle")
        );
      }) || selectablePlans[0]
    );
  };

  /**
   * Gets the plan type for a category
   *
   * @param categoryID
   * @returns
   */
  let getPlanType = (categoryID: string) => {
    if (!categoryID) {
      return;
    }

    let planType = _.findWhere(planTypes, { _id: categoryID });

    if (!planType) {
      return null;
    }

    planType = _.clone(planType);

    planType.name += " Meal Plans";

    return planType;
  };

  /**
   * Selects a plan
   *
   * @param plan
   */
  let selectPlan = (plan: any) => {
    setHasInitializedPlanSelection(true);
    setPlan(plan);
    setSelectedPlanCriteria({
      planTypeID: plan?.planType?._id,
      quantity: plan?.quantity,
      frequency: plan?.frequency,
      procurement: plan?.procurement,
    });
  };

  let continueWithSelectedPlan = () => {
    if (!persistedSelectedPlan) {
      return;
    }

    setPlan(persistedSelectedPlan);
    setStep("checkout");
  };

  const selectLocation = (store: any) => {
    setSubmitting(store?._id);

    API.setAppUserParameter("storeID", store?._id)
      .then(async (data: any) => {
        console.log(data?.data?.data?.user);

        await StorageUtils.set("user_customer", data?.data?.data?.user);

        API.getAccount()
          .then(
            async (data: any) => {
              console.log(data?.data?.data?.store);

              PubSub.publish("userUpdated", data?.data?.data?.user);

              if (typeof onLocationChange == "function") {
                onLocationChange(data?.data?.data?.store);
              }

              await StorageUtils.set("user_customer", data?.data?.data?.user);
              await StorageUtils.set("user_store", data?.data?.data?.store);
            },
            (e) => {
              console.error(e);
            },
          )
          .finally(() => {
            setStep("plans");
            setSubmitting(false);
          });
      })
      .catch((e) => {
        console.error(e);

        setSubmitting(false);
      })
      .finally(() => {});
  };

  let fetchCheckoutIntent = (email: any) => {
    //console.log("FETCH STRIPE", email);

    if (fetchingStripe) {
      return;
    }

    setFetchingStripe(true);

    //console.log("FETCH");

    API.getStripeCheckoutIntent(email)
      .then(
        (data: any) => {
          //console.log(data.data);

          let opts: any = {
            cssSrc: "https://fonts.googleapis.com/css?family=Karla",
            loader: "always",
          };

          opts.clientSecret = data?.data?.data?.clientSecret;

          setStripeOptions(opts);
          setStripeCustomerID(data.data.data.stripeCustomerID);
        },
        (e) => {
          console.error(e);
        },
      )
      .finally(() => {});
  };

  /**
   * Handles the default coupon
   *
   * @param store
   */
  let handleDefaultCoupon = async (store: any, lead: any) => {
    if (store?.operations?.defaultCoupon?.coupon) {
      let coupon = store?.operations?.defaultCoupon?.coupon;

      StorageUtils.get("checkout_overrideDefaultCoupon").then((data: any) => {
        if (data) {
          let date: any = null;

          try {
            date = moment(date);

            // Allow three days of coupon override
            if (moment().subtract(7, "days").isSameOrBefore(date)) {
              coupon.defaultCoupon = true;
              coupon.defaultStoreID = store?._id;

              SegmentUtils.track("Coupon Applied", {
                coupon_id: coupon?.code,
                coupon_name: coupon?.name,
                coupon_terms: coupon?.terms ? coupon?.terms : "",
                type: "discount",
              });

              setCoupon(coupon);

              PubSub.publish(Event.CHECKOUT.COUPON_UPDATED, {
                coupon: coupon,
                forceShow: true,
              });

              StorageUtils.set("checkout_coupon", coupon);
            } else {
              // KEEP COUPON
            }
          } catch (e) {
            coupon.defaultCoupon = true;
            coupon.defaultStoreID = store?._id;

            SegmentUtils.track("Coupon Applied", {
              coupon_id: coupon?.code,
              coupon_name: coupon?.name,
              coupon_terms: coupon?.terms ? coupon?.terms : "",
              type: "discount",
            });

            setCoupon(coupon);

            PubSub.publish(Event.CHECKOUT.COUPON_UPDATED, {
              coupon: coupon,
              forceShow: true,
            });

            StorageUtils.set("checkout_coupon", coupon);
          }
        } else {
          coupon.defaultCoupon = true;
          coupon.defaultStoreID = store?._id;

          SegmentUtils.track("Coupon Applied", {
            coupon_id: coupon?.code,
            coupon_name: coupon?.name,
            coupon_terms: coupon?.terms ? coupon?.terms : "",
            type: "discount",
          });

          setCoupon(coupon);

          PubSub.publish(Event.CHECKOUT.COUPON_UPDATED, {
            coupon: coupon,
            forceShow: true,
          });

          StorageUtils.set("checkout_coupon", coupon);
        }
      });
    } else if (lead?.coupon?.code) {
      API.getCouponByCode(
        lead?.coupon?.code,
        lead?.storeID ? lead?.storeID : "",
      ).then(
        (data: any) => {
          let coupon = data?.data?.data?.coupon;

          setCoupon(coupon);

          PubSub.publish(Event.CHECKOUT.COUPON_UPDATED, {
            coupon: coupon,
            forceShow: true,
          });

          StorageUtils.set("checkout_coupon", coupon);
        },
        (e) => {
          console.error(e);
        },
      );
    }
  };

  /**
   *
   * @param asMoment
   * @returns any
   */
  /**
   *
   * @param asMoment
   * @returns any
   */
  let getFirstBillingDate = (store: any, asMoment = false) => {
    let firstBillDate =
      moment().day() <= 3
        ? moment().day(6).startOf("day")
        : moment().add(1, "week").day(6).startOf("day");

    if (
      store?.operations?.storeOpening?.firstBillDate &&
      firstBillDate.isBefore(
        moment(store?.operations?.storeOpening?.firstBillDate),
      )
    ) {
      firstBillDate = moment(store?.operations?.storeOpening?.firstBillDate);
    }

    if (store?.operations?.blackoutDates?.length) {
      while (
        store?.operations?.blackoutDates.indexOf(
          firstBillDate.format("YYYY-MM-DD"),
        ) >= 0
      ) {
        firstBillDate.add(1, "week");
      }
    }

    if (asMoment) {
      return firstBillDate;
    }

    return firstBillDate.format("MMMM DD, YYYY");
  };

  /**
   * Loads a coupon
   *
   * @param code
   */
  let loadCoupon = (code: any = "") => {
    setCouponSubmitting(true);
    setCouponError("");

    SegmentUtils.track("Coupon Entered", {
      cart_id:
        (lead?.userID ? lead?.userID : lead?._id) +
        "_cart_" +
        moment().format("YYYY-MM-DD"),
      coupon_id: code,
      type: "discount",
    });

    API.getCouponByCode(code, lead?.storeID ? lead?.storeID : "")
      .then(
        (data: any) => {
          const coupon: any = data?.data?.data?.coupon;

          setCoupon(coupon);
          setCouponCode(coupon?.code);

          SegmentUtils.track("Coupon Applied", {
            cart_id:
              (lead?.userID ? lead?.userID : lead?._id) +
              "_cart_" +
              moment().format("YYYY-MM-DD"),
            coupon_id: coupon?.code,
            coupon_name: coupon?.name,
            coupon_terms: coupon?.terms ? coupon?.terms : "",
            type: "discount",
          });

          if (coupon) {
            StorageUtils.set("checkout_coupon", coupon);
            PubSub.publish(Event.CHECKOUT.COUPON_UPDATED, { coupon });
          }
        },
        (e: any) => {
          console.error(e);

          SegmentUtils.track("Coupon Denied", {
            cart_id:
              (lead?.userID ? lead?.userID : lead?._id) +
              "_cart_" +
              moment().format("YYYY-MM-DD"),
            coupon_id: code,
            type: "discount",
            reason: "The coupon code you entered is invalid.",
          });

          setCouponError("The coupon code you entered is invalid.");
        },
      )
      .finally(() => {
        setCouponSubmitting(false);
      });
  };

  /**
   * Load a referral coupon
   *
   * @param code
   * @returns
   */
  let loadReferral = (code: any = "") => {
    if (code?.toLowerCase().indexOf("m-") != 0) {
      setReferralError("The referral code you entered is invalid.");
      return;
    }

    setReferralSubmitting(true);
    setReferralError("");

    SegmentUtils.track("Coupon Entered", {
      cart_id:
        (lead?.userID ? lead?.userID : lead?._id) +
        "_cart_" +
        moment().format("YYYY-MM-DD"),
      coupon_id: code,
      type: "referral",
    });

    API.getCouponByCode(code?.toUpperCase(), lead?.storeID ? lead?.storeID : "")
      .then(
        async (data: any) => {
          const coupon = data?.data?.data?.coupon;

          if (!coupon?.referralProgram) {
            setReferralError("The referral code you entered is invalid.");
            return;
          }

          setReferral(coupon);
          setReferralCode(coupon?.code);

          SegmentUtils.track("Coupon Applied", {
            cart_id:
              (lead?.userID ? lead?.userID : lead?._id) +
              "_cart_" +
              moment().format("YYYY-MM-DD"),
            coupon_id: coupon?.code,
            coupon_name: coupon?.name,
            coupon_terms: coupon?.terms ? coupon?.terms : "",
            type: "referral",
          });

          if (coupon) {
            StorageUtils.set("checkout_referral", coupon);

            if (!coupon) {
              PubSub.publish(Event.CHECKOUT.COUPON_UPDATED, { coupon });
            }
          }
        },
        (e: any) => {
          console.error(e);

          SegmentUtils.track("Coupon Denied", {
            cart_id:
              (lead?.userID ? lead?.userID : lead?._id) +
              "_cart_" +
              moment().format("YYYY-MM-DD"),
            coupon_id: code,
            type: "referral",
            reason: "The referral code you entered is invalid.",
          });

          setReferralError("The referral code you entered is invalid.");
        },
      )
      .finally(() => {
        setReferralSubmitting(false);
      });
  };

  /**
   * Loads the stores based on the user's location
   *
   * @param stores
   * @param coordinates
   */
  const loadStoreResults = async (
    stores: any,
    coordinates: any,
    zipCode: any,
  ) => {
    //console.log(stores, coordinates);

    let filteredStores = _.filter(stores, (store: any) => {
      let distance = getStoreDistance(coordinates, store);

      //console.log(distance);

      return distance <= 25;
    });

    if (zipCode) {
      let inTerritoryStores = _.filter(filteredStores, (store: any) => {
        return store?.dedicatedTerritories?.includes(zipCode);
      });

      //console.log(inTerritoryStores, zipCode);

      let outOfTerritoryStores = _.filter(filteredStores, (store: any) => {
        return !store?.dedicatedTerritories?.includes(zipCode);
      });

      //console.log(outOfTerritoryStores);

      inTerritoryStores = _.sortBy(inTerritoryStores, (store: any) => {
        return getStoreDistance(coordinates, store);
      });

      outOfTerritoryStores = _.sortBy(outOfTerritoryStores, (store: any) => {
        return getStoreDistance(coordinates, store);
      });

      filteredStores = _.union(inTerritoryStores, outOfTerritoryStores);
    }

    setFilteredStores(filteredStores);
  };

  /**
   * Fetches all the stores
   *
   * @returns
   */
  let loadStores = async () => {
    setLoadingStores(true);

    return new Promise((resolve, reject) => {
      API.getStores()
        .then(
          (data: any) => {
            let stores = data?.data?.data?.stores?.length
              ? data?.data?.data?.stores
              : [];

            stores = _.filter(stores, (store: any) => {
              return (
                store &&
                (DateUtils.storeIsPrelaunch(store) ||
                  DateUtils.storeIsLive(store))
              );
            });

            stores = _.filter(stores, (store: any) => {
              return store?.type == "retail";
            });

            stores = stores.map((st: any) => {
              st.name = st.name?.replace("Project LeanNation", "PLN").trim();

              if (st?.location?.address?.city) {
                st.location.address.city = st.location.address.city?.trim();
              }

              return st;
            });

            stores = _.sortBy(stores, "name");

            //console.log(stores);

            setAllStores(stores);

            //console.log(location);

            if (location?.geographic) {
              loadStoreResults(stores, location?.geographic, location?.zipCode);
            } else {
              setFilteredStores(stores);
            }

            resolve(stores);
          },
          (e) => {
            console.error(e);

            reject(e);
          },
        )
        .finally(() => {
          setLoadingStores(false);
        });
    });
  };

  const findDeliveryLocation = (zipCode: any) => {
    if (!zipCode) {
      return null;
    }

    return _.findWhere(allDeliveryStores, (st: any) => {
      return st?.territories?.includes(zipCode);
    });
  };

  /**
   * Reverse geocodes a location
   *
   * @param lat
   * @param lng
   */
  const reverseGeocodeLocation = async (lat: any, lng: any) => {
    let res: any = await API.reverseGeocodeLatLng(lat, lng);

    //console.log(res);

    let result = res?.data?.data?.geocode?.results?.length
      ? res?.data?.data?.geocode?.results[0]
      : null;
    let geographic = {
      lat: lat,
      lng: lng,
    };

    let zipCode = result?.address_components?.find((component: any) => {
      return component?.types?.includes("postal_code");
    });

    if (zipCode) {
      zipCode = zipCode?.short_name;
    } else {
      zipCode = null;
    }

    setLocation({ result, geographic, zipCode });
    setDeliveryLocation({ result, geographic, zipCode });
    setFilterOption("nearby");
  };

  useEffect(() => {
    if (deliveryLocation?.zipCode) {
      API.getStoresForZip(deliveryLocation?.zipCode).then((res: any) => {
        setAllDeliveryStores(res?.data?.data?.stores);

        console.log(res?.data?.data?.stores);

        if (
          res?.data?.data?.stores
            ?.map((st: any) => st?._id)
            ?.includes(store?._id)
        ) {
          setDeliveryAvailable(true);
        } else {
          setDeliveryAvailable(false);
        }
      });
    } else if (deliveryLocation) {
      setDeliveryAvailable(false);
      setAllDeliveryStores([]);
    } else {
      setDeliveryAvailable(true);
      setAllDeliveryStores([]);
    }
  }, [deliveryLocation, store]);

  useEffect(() => {
    if (store) {
      console.log(store);

      setStep("plans");

      loadPlanOptions(store);

      handleDefaultCoupon(store, lead ? lead : null);
    } else {
      setStep("location");

      Geolocation.checkPermissions()
        .then((permissions) => {
          if (
            permissions?.location == "granted" ||
            permissions?.location == "prompt"
          ) {
            Geolocation.getCurrentPosition()
              .then((position) => {
                if (position.coords) {
                  reverseGeocodeLocation(
                    position.coords.latitude,
                    position.coords.longitude,
                  );
                }
              })
              .catch((e) => {
                console.error(e);
              });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [store, lead]);

  useEffect(() => {
    loadStores();
  }, []);

  useEffect(() => {
    console.log("LEAD", lead);

    if (lead?.email) {
      console.log("HERE");

      fetchCheckoutIntent(lead?.email);
    }
  }, [lead]);

  useEffect(() => {
    if (location?.geographic && allStores?.length) {
      loadStoreResults(allStores, location?.geographic, location?.zipCode);
    }
  }, [location, allStores]);

  let _loadStripe = async () => {
    if (!stripe) {
      const stripe = await loadStripe(Constants.STRIPE_KEY);

      setStripe(stripe);
    }
  };

  useEffect(() => {
    if (open) {
      _loadStripe();
    }
  }, [open]);

  const visiblePlans =
    getPlansForCategory(
      activePlanType,
      activeProcurement,
      activeFrequency,
      planOptions,
    ) || [];

  const activeSelectedPlan = _.find(visiblePlans, (candidatePlan: any) => {
    if (!selectedPlanCriteria || !isPlanSelectable(candidatePlan)) {
      return false;
    }

    return (
      selectedPlanCriteria?.planTypeID == candidatePlan?.planType?._id &&
      selectedPlanCriteria?.quantity == candidatePlan?.quantity &&
      selectedPlanCriteria?.frequency == candidatePlan?.frequency &&
      selectedPlanCriteria?.procurement == candidatePlan?.procurement
    );
  });

  const persistedSelectedPlan =
    _.find(planOptions, (candidatePlan: any) => {
      if (!selectedPlanCriteria) {
        return false;
      }

      return (
        selectedPlanCriteria?.planTypeID == candidatePlan?.planType?._id &&
        selectedPlanCriteria?.quantity == candidatePlan?.quantity &&
        selectedPlanCriteria?.frequency == candidatePlan?.frequency &&
        selectedPlanCriteria?.procurement == candidatePlan?.procurement
      );
    }) || plan;

  useEffect(() => {
    if (!open) {
      setHasInitializedPlanSelection(false);
      setSelectedPlanCriteria(null);
      setPlan(null);
      setCheckoutSubmitTrigger(0);
      setCheckoutFooterState({
        canSubmit: false,
        submitting: false,
        requiresSubscriptionTerms: false,
        confirmSubscriptionTerms: false,
      });
    }
  }, [open]);

  useEffect(() => {
    if (hasInitializedPlanSelection || selectedPlanCriteria) {
      return;
    }

    const defaultPlan = getDefaultSelectablePlan(visiblePlans);

    if (!defaultPlan) {
      return;
    }

    setSelectedPlanCriteria({
      planTypeID: defaultPlan?.planType?._id,
      quantity: defaultPlan?.quantity,
      frequency: defaultPlan?.frequency,
      procurement: defaultPlan?.procurement,
    });
    setPlan(defaultPlan);
    setHasInitializedPlanSelection(true);
  }, [
    hasInitializedPlanSelection,
    selectedPlanCriteria,
    visiblePlans,
    deliveryAvailable,
    deliveryLocation,
  ]);

  return (
    <>
      <IonModal
        mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
        isOpen={open}
        className="modal-mealdetail"
        onDidDismiss={() => setOpen(false)}
      >
        <IonHeader>
          <IonToolbar
            mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
            className={
              Capacitor.isNativePlatform()
                ? "box-modal-toolbar-native"
                : "box-modal-toolbar-web"
            }
            style={{ borderBottom: "none" }}
            color="white"
          >
            <IonTitle>
              {step == "plans" ? "Explore PLN+ Plans" : null}
              {step == "checkout" ? "Review & Confirm" : null}
              {step == "location" ? "Find A Location" : null}
            </IonTitle>
            <IonButtons slot="start">
              {step == "location" || (step == "plans" && store) ? (
                <IonButton onClick={() => setOpen(false)}>Close</IonButton>
              ) : null}
              {(step == "plans" && !store) || step == "checkout" ? (
                <IonButton
                  onClick={() =>
                    setStep(step == "plans" ? "location" : "plans")
                  }
                >
                  <IonIcon icon={chevronBack} /> Back
                </IonButton>
              ) : null}
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {step == "location" ? (
            <div className="ion-padding">
              <div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <div className="">
                    {location ? (
                      <>
                        <div className="rounded relative">
                          <div className="absolute left-2 top-3 sm:top-3.5 sm:left-2.5 text-lg h-[2rem] w-[2rem]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="h-[1.3rem] w-[1.3rem]"
                            >
                              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                              <circle cx="12" cy="10" r="3" />
                            </svg>
                          </div>
                          <p className="block whitespace-nowrap overflow-hidden text-ellipsis w-full text-base sm:text-md pr-[2.25rem] pl-[2.25rem] rounded-tr rounded-tl border-0 py-2.5 sm:py-3 text-gray-900 shadow-sm outline-0 border-[1px] border-gray-100 placeholder:text-gray-400 transition-all focus:border-orange-500 sm:leading-6 rounded-br rounded-bl">
                            {location?.result?.formatted_address}
                          </p>
                          <div
                            onClick={() => {
                              setLocation(null);
                              setDeliveryLocation(null);
                              setFilterOption("all");
                            }}
                            className="cursor-pointer absolute right-2.5 top-3 sm:top-3.5 sm:right-3 text-2xl h-[2rem] w-[1.5rem]"
                          >
                            <IonIcon
                              icon={closeCircleOutline}
                              className="text-gray-900"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <LocationSearchInputV2
                          onChange={(data: any) => {
                            console.log("change", data);
                          }}
                          onSelect={(data: any) => {
                            console.log("select", data);

                            setFilterOption("nearby");

                            let zipCode =
                              data?.result?.address_components?.find(
                                (component: any) => {
                                  return component?.types?.includes(
                                    "postal_code",
                                  );
                                },
                              );

                            if (zipCode) {
                              zipCode = zipCode?.short_name;
                            } else {
                              zipCode = null;
                            }

                            setLocation({
                              ...data,
                              zipCode,
                            });

                            setDeliveryLocation({
                              ...data,
                              zipCode,
                            });
                          }}
                        ></LocationSearchInputV2>
                      </>
                    )}
                  </div>

                  {locationFormError ? (
                    <p className="mt-2 text-red-500 text-sm text-center">
                      {locationFormError}
                    </p>
                  ) : null}
                </form>
                <div className="my-3 h-[1px] bg-gray-100"></div>
                <IonSegment
                  disabled={loadingStores}
                  value={filterOption}
                  onIonChange={(e: any) => {
                    setFilterOption(e.detail.value);
                  }}
                  mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
                >
                  <IonSegmentButton disabled={!location} value="nearby">
                    <IonLabel>Nearby</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="all">
                    <IonLabel>All Locations</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
                <div className="mt-3">
                  {loadingStores ? (
                    <>
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                    </>
                  ) : (
                    <div>
                      {filterOption == "nearby" ? (
                        <>
                          {filteredStores?.length ? (
                            <>
                              {filteredStores?.map((store: any) => {
                                return (
                                  <div
                                    onClick={() => {
                                      selectLocation(store);
                                    }}
                                    className={`p-3 cursor-pointer items-center flex gap-x-3 rounded-lg border border-gray-100 mb-3 ${
                                      submitting
                                        ? "bg-gray-50 text-gray-300"
                                        : "text-gray-900"
                                    }`}
                                    key={store?._id}
                                  >
                                    <div className="grow">
                                      <p className="text-base font-[SourceSerif]">
                                        {store?.name}
                                        {location?.geographic ? (
                                          <span className="pl-1.5 text-sm relative -top-[1px]">
                                            (
                                            {getStoreDistance(
                                              location?.geographic,
                                              store,
                                            )?.toFixed(1)}{" "}
                                            mi)
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                      <p className="text-sm">
                                        {
                                          store?.location?.address
                                            ?.formattedAddress
                                        }
                                      </p>
                                    </div>
                                    <div>
                                      {submitting == store?._id ? (
                                        <IonSpinner name="dots"></IonSpinner>
                                      ) : null}
                                      {!submitting ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          className="h-8 w-8"
                                        >
                                          <path d="m9 18 6-6-6-6" />
                                        </svg>
                                      ) : null}
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              <div className="rounded-lg border border-gray-100 p-3">
                                <p className="text-base text-lg text-center mb-2 font-[SourceSerif]">
                                  No Locations Nearby (Yet!)
                                </p>
                                <p className="text-base text-center">
                                  We're growing fast so stay tuned, a PLN
                                  community could be coming your way soon!
                                </p>
                                <div className="mt-3">
                                  <button
                                    onClick={() => {
                                      setOpen(false);
                                    }}
                                    className="w-full rounded-xl bg-orange-500 text-white px-4 py-2.5"
                                  >
                                    Return To Menu
                                  </button>
                                  <button
                                    onClick={() => {
                                      setFilterOption("all");
                                    }}
                                    className="w-full text-orange-500 px-4 mt-2 py-2"
                                  >
                                    View All Locations
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {allStores?.map((store: any) => {
                            return (
                              <div
                                onClick={() => {
                                  selectLocation(store);
                                }}
                                className={`p-3 cursor-pointer items-center flex gap-x-3 rounded-lg border border-gray-100 mb-3 ${
                                  submitting
                                    ? "bg-gray-50 text-gray-300"
                                    : "text-gray-900"
                                }`}
                                key={store?._id}
                              >
                                <div className="grow">
                                  <p className="text-base font-[SourceSerif]">
                                    {store?.name}
                                    {location?.geographic ? (
                                      <span className="pl-1.5 text-sm relative -top-[1px]">
                                        (
                                        {getStoreDistance(
                                          location?.geographic,
                                          store,
                                        )?.toFixed(1)}{" "}
                                        mi)
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                  <p className="text-sm">
                                    {store?.location?.address?.formattedAddress}
                                  </p>
                                </div>
                                <div>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="h-8 w-8"
                                  >
                                    <path d="m9 18 6-6-6-6" />
                                  </svg>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          {step == "plans" ? (
            <>
              {coupon ? (
                <div className="ion-padding sticky text-sm font-bold z-[999] top-0 p-2.5 bg-orange-500 text-center text-white">
                  Limited time offer!{" "}
                  {StringUtils.generateCouponValueString(coupon)}
                </div>
              ) : null}
              <div className="ion-padding">
                <div>
                  <div
                    onClick={() => {
                      if (typeof onLocationChange == "function") {
                        onLocationChange(null);
                      }
                      setStep("location");
                    }}
                    className="p-2.5 border rounded-lg border-gray-100transition-all rounded-lg w-full"
                  >
                    <div className="text-center">
                      <div>
                        <div
                          style={{ lineHeight: 1.1 }}
                          className="text-xs text-truncate text-gray-900"
                        >
                          Viewing PLN+ Plans At
                        </div>
                        <div
                          style={{
                            lineHeight: 1.2,
                            minWidth: 0,
                          }}
                          className="text-base mt-1 text-gray-900 font-[SourceSerif] sm:font-medium tracking-tight text-truncate"
                        >
                          {store?.name
                            ?.replace("Project LeanNation", "PLN")
                            ?.trim()}
                        </div>
                        <div
                          style={{ lineHeight: 1.2 }}
                          className="text-xs mt-1 text-truncate text-gray-900"
                        >
                          {store?.location?.address?.formattedAddress}
                        </div>
                        <div
                          style={{ lineHeight: 1.2 }}
                          className="text-xs mt-1 text-truncate text-orange-500"
                        >
                          Change Location
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid mt-3 grid-cols-2 gap-x-0 items-center rounded-lg border border-gray-100">
                  <div
                    style={{ lineHeight: 1.2 }}
                    className={`h-[40px] ${
                      activeProcurement?.procurement == "pickup"
                        ? "bg-orange-500 text-white"
                        : "bg-white text-gray-700"
                    } py-[0.6rem] text-center px-2 transition-all rounded-lg text-base font-bold  cursor-pointer`}
                    onClick={() => {
                      setActiveProcurement(
                        _.findWhere(procurementTypes, {
                          procurement:
                            activeProcurement?.procurement == "pickup"
                              ? "delivery"
                              : "pickup",
                        }),
                      );

                      const allPlans = getPlansForCategory(
                        activePlanType,
                        activeProcurement,
                        activeFrequency,
                        planOptions,
                      );

                      const planType = _.findWhere(planTypes, {
                        _id: activePlanType,
                      });

                      trackProductListViewed(planType, allPlans);
                    }}
                  >
                    Pickup
                  </div>
                  <div
                    style={{ lineHeight: 1.2 }}
                    onClick={() => {
                      setActiveProcurement(
                        _.findWhere(procurementTypes, {
                          procurement:
                            activeProcurement?.procurement == "pickup"
                              ? "delivery"
                              : "pickup",
                        }),
                      );

                      const allPlans = getPlansForCategory(
                        activePlanType,
                        activeProcurement,
                        activeFrequency,
                        planOptions,
                      );

                      const planType = _.findWhere(planTypes, {
                        _id: activePlanType,
                      });

                      trackProductListViewed(planType, allPlans);
                    }}
                    className={`h-[40px] flex items-center justify-center cursor-pointer ${
                      activeProcurement?.procurement == "delivery"
                        ? "bg-orange-500 text-white"
                        : "bg-white text-gray-700"
                    } ${
                      !deliveryAvailable ? "opacity-50" : ""
                    } py-[0.6rem] text-center px-2 transition-all rounded-lg text-base font-bold  `}
                  >
                    <div>
                      Delivery
                      {!deliveryAvailable ? (
                        <div className={`text-xs mt-0`}>
                          Not Available In Your Area
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                {activeProcurement?.procurement == "delivery" ? (
                  <>
                    <div className="rounded-lg border bg-white p-2.5 mt-3">
                      <h5 className="text-sm mb-2 text-center">
                        Delivery Address
                      </h5>

                      {deliveryLocation ? (
                        <>
                          <div className="rounded relative">
                            <div className="absolute left-2 top-3 sm:top-3.5 sm:left-2.5 text-lg h-[2rem] w-[2rem]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="h-[1.3rem] w-[1.3rem]"
                              >
                                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                <circle cx="12" cy="10" r="3" />
                              </svg>
                            </div>
                            <p className="block whitespace-nowrap overflow-hidden text-ellipsis w-full text-base sm:text-md pr-[2.25rem] pl-[2.25rem] rounded-tr rounded-tl border-0 py-2.5 sm:py-3 text-gray-900 shadow-sm outline-0 border-[1px] border-gray-100 placeholder:text-gray-400 transition-all focus:border-orange-500 sm:leading-6 rounded-br rounded-bl">
                              {deliveryLocation?.result?.formatted_address}
                            </p>
                            <div
                              onClick={() => {
                                setDeliveryLocation(null);
                              }}
                              className="cursor-pointer absolute right-2.5 top-3 sm:top-3.5 sm:right-3 text-2xl h-[2rem] w-[1.5rem]"
                            >
                              <IonIcon
                                icon={closeCircleOutline}
                                className="text-gray-900"
                              />
                            </div>
                          </div>
                          {!deliveryAvailable ? (
                            <div className="mt-3 pt-3 border-t border-gray-100">
                              {findDeliveryLocation(
                                deliveryLocation?.zipCode,
                              ) ? (
                                <>
                                  <p className="text-center">
                                    Another store provides delivery in your
                                    area. Change stores or explore pickup plans
                                    at{" "}
                                    {store?.name
                                      ?.replace("Project LeanNation", "PLN")
                                      ?.trim()}
                                    &nbsp; to continue.
                                  </p>
                                  <div className="grid mt-3 grid-cols-1 md:grid-cols-2 gap-2">
                                    <button
                                      onClick={() => {
                                        if (
                                          typeof onLocationChange === "function"
                                        ) {
                                          let store = findDeliveryLocation(
                                            deliveryLocation?.zipCode,
                                          );

                                          onLocationChange(store);

                                          setTimeout(() => {
                                            setDeliveryAvailable(true);
                                            setActiveProcurement(
                                              _.findWhere(procurementTypes, {
                                                procurement: "delivery",
                                              }),
                                            );
                                          }, 10);

                                          // TODO: toast for confirming new store change
                                        }
                                      }}
                                      className={`tracking-tight grow bg-orange-500 text-white hover:bg-orange-700 cursor-pointer py-[0.5rem] px-[0.75rem] ${
                                        Capacitor.getPlatform() == "android"
                                          ? "rounded shadow-sm text-uppercase h-[40px]"
                                          : "rounded-lg h-[40px]"
                                      }  text-base font-bold w-full`}
                                    >
                                      Change Store For Delivery
                                    </button>
                                    <button
                                      onClick={() => {
                                        setActiveProcurement(
                                          _.findWhere(procurementTypes, {
                                            procurement: "pickup",
                                          }),
                                        );
                                      }}
                                      style={{
                                        borderColor: "#FF6B2B",
                                      }}
                                      className={`tracking-tight grow border transition-colors text-orange-500 border-orange-500 hover:bg-orange-500 hover:text-white cursor-pointer py-[0.5rem] px-[0.75rem] ${
                                        Capacitor.getPlatform() == "android"
                                          ? "rounded shadow-sm text-uppercase h-[40px]"
                                          : "rounded-lg h-[40px]"
                                      }  text-base font-bold w-full`}
                                    >
                                      View Pickup Plans
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <p className="text-center">
                                    Delivery is not currently available in your
                                    area at this time.
                                  </p>
                                  <div className="grid mt-3 grid-cols-1 md:grid-cols-2 gap-2">
                                    <button
                                      onClick={() => {
                                        setActiveProcurement(
                                          _.findWhere(procurementTypes, {
                                            procurement: "pickup",
                                          }),
                                        );
                                      }}
                                      className={`tracking-tight grow bg-orange-500 text-white hover:bg-orange-700 cursor-pointer py-[0.5rem] px-[0.75rem] ${
                                        Capacitor.getPlatform() == "android"
                                          ? "rounded shadow-sm text-uppercase h-[40px]"
                                          : "rounded-lg h-[40px]"
                                      }  text-base font-bold w-full`}
                                    >
                                      View Pickup Plans
                                    </button>
                                    <button
                                      onClick={() => {
                                        setDeliveryLocation(null);
                                        setDeliveryAvailable(true);
                                      }}
                                      style={{
                                        borderColor: "#FF6B2B",
                                      }}
                                      className={`tracking-tight grow border transition-colors text-orange-500 border-orange-500 hover:bg-orange-500 hover:text-white cursor-pointer py-[0.5rem] px-[0.75rem] ${
                                        Capacitor.getPlatform() == "android"
                                          ? "rounded shadow-sm text-uppercase h-[40px]"
                                          : "rounded-lg h-[40px]"
                                      }  text-base font-bold w-full`}
                                    >
                                      Change Delivery Address
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          ) : null}
                        </>
                      ) : (
                        <LocationSearchInputV2
                          onChange={(data: any) => {
                            console.log("change", data);
                          }}
                          onSelect={(data: any) => {
                            console.log("select", data);

                            let zipCode =
                              data?.result?.address_components?.find(
                                (component: any) => {
                                  return component?.types?.includes(
                                    "postal_code",
                                  );
                                },
                              );

                            if (zipCode) {
                              zipCode = zipCode?.short_name;
                            } else {
                              zipCode = null;
                            }

                            setDeliveryLocation({
                              ...data,
                              zipCode,
                            });
                          }}
                          placeholder="Enter Your Address"
                        />
                      )}
                    </div>
                  </>
                ) : null}
                {frequencyTypes?.length > 1 ? (
                  <>
                    <select
                      id="frequency"
                      value={activeFrequency}
                      onChange={(e) => {
                        setActiveFrequency(e.target.value);
                        const allPlans = getPlansForCategory(
                          activePlanType,
                          activeProcurement,
                          activeFrequency,
                          planOptions,
                        );

                        const planType = _.findWhere(planTypes, {
                          _id: activePlanType,
                        });

                        trackProductListViewed(planType, allPlans);
                      }}
                      className="mt-3 bg-white text-capitalize border border-gray-100 text-gray-900 text-base rounded-lg outline-0 focus:ring-orange-500 focus:border-orange-500 block w-full p-2 h-[40px] placeholder-gray-400"
                    >
                      <option disabled>Select An Order Frequency</option>
                      {frequencyTypes?.map((freq: any) => (
                        <option value={freq} key={freq}>
                          {activeProcurement?.procurement == "pickup"
                            ? "Pickup Your Order"
                            : "Receive Your Order"}
                          &nbsp;
                          {freq == "biweekly" ? "Bi-Weekly" : freq}
                        </option>
                      ))}
                    </select>
                  </>
                ) : null}
                <div className="grid mt-3 mx-auto grid-cols-2 gap-x-0 items-center rounded-lg border border-gray-100">
                  {planTypes?.map((planType: any, index: number) => (
                    <div
                      key={index}
                      onClick={() => {
                        setActivePlanType(planType?._id);

                        const p = _.findWhere(planTypes, {
                          _id: planType?._id,
                        });

                        const plans = getPlansForCategory(
                          planType?._id,
                          activeProcurement,
                          activeFrequency,
                          planOptions,
                        );

                        let allMeals =
                          store?.menus?.meals[planType?._id]?.active?.meals;

                        setAllMeals(allMeals);

                        trackProductListViewed(p, plans);
                      }}
                      style={{ lineHeight: 1.2 }}
                      className={`${
                        activePlanType == planType?._id
                          ? "bg-orange-500 text-white cursor-pointer"
                          : "bg-white text-gray-700 cursor-pointer"
                      } py-[0.6rem] text-center px-2 transition-all rounded-lg text-base font-bold`}
                    >
                      <div>{planType?.name} Meal Plans</div>
                      <div className="text-xs font-medium">
                        {getPlanType(planType?._id)?.calorieMin}-
                        {getPlanType(planType?._id)?.calorieMax} Calories / Meal
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4 text-center sm:max-w-[620px] sm:mx-auto">
                  <p className=" text-base leading-[1.25rem] sm:leading-5 font-normal text-gray-900 px-3 my-4">
                    Our plans include tasty, perfectly portioned meals to help
                    you hit your health goals!
                  </p>
                </div>
                <div className="grid grid-cols-3 gap-x-3 mt-2">
                  {visiblePlans?.map((planOption: any, i: number) => (
                    <>
                      {(() => {
                        const planIsSelected =
                          getPlanSelectionKey(activeSelectedPlan) ==
                          getPlanSelectionKey(planOption);
                        const planIsSelectable = isPlanSelectable(planOption);

                        return (
                      <div
                        key={i}
                        className={`relative rounded-lg ${
                          !isSelectingLocation &&
                          ((planOption?.procurement == "delivery" &&
                            deliveryAvailable &&
                            deliveryLocation) ||
                            planOption?.procurement !=
                              "delivery") &&
                          "hover:bg-orange-50 hover:border-orange-500 cursor-pointer"
                        }  transition-all border-[1px] py-[1rem] pl-[0.5rem] pr-[0.5rem] ${
                          planOption?.quantity == 12 &&
                          planOption?.planType?.name
                            ?.toLowerCase()
                            ?.includes("lifestyle") &&
                          !isSelectingLocation &&
                          ((planOption?.procurement == "delivery" &&
                            deliveryAvailable &&
                            deliveryLocation) ||
                            planOption?.procurement != "delivery")
                            ? "shadow hover:shadow-lg border-gray-200"
                            : "shadow-sm hover:shadow border-gray-100"
                        } ${
                          planOption?.procurement == "delivery" &&
                          (!deliveryAvailable ||
                            !deliveryLocation)
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        } ${
                          planIsSelected
                            ? "bg-orange-50 border-orange-500 shadow"
                            : ""
                        } ${
                          isSelectingLocation &&
                          "bg-gray-50"
                        } ${
                          planOption?.quantity == 12 &&
                          planOption?.planType?.name
                            ?.toLowerCase()
                            ?.includes("lifestyle")
                            ? "mt-[1rem]"
                            : "mt-[1rem]"
                        }`}
                        onClick={() => {
                          if (
                            (planOption?.procurement == "delivery" &&
                              !deliveryLocation) ||
                            !deliveryAvailable
                          ) {
                            return;
                          }

                          selectPlan(planOption);
                        }}
                      >
                        {planOption?.quantity == 12 &&
                        planOption?.planType?.name
                          ?.toLowerCase()
                          ?.includes("lifestyle") &&
                        (planOption?.procurement != "delivery" ||
                          (planOption?.procurement == "delivery" &&
                            deliveryLocation &&
                            deliveryAvailable)) ? (
                          <>
                            <div
                              style={{
                                transform: "translateX(-50%)",
                              }}
                              className="flex items-center justify-center w-[80px] sm:w-[100px] absolute top-[-12px] left-[50%] bg-orange-500 p-1 rounded-lg"
                            >
                              <div>
                                <svg
                                  className="fill-white h-[12px] w-[12px] relative top-[-2px]"
                                  width="12"
                                  height="11"
                                  viewBox="0 0 12 11"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                                    fill="inherit"
                                  />
                                </svg>
                              </div>
                              <div
                                style={{ lineHeight: 1.2 }}
                                className="text-sm sm:text-base text-white  ml-[0.1rem] sm:ml-[0.3rem] font-medium leading-4 tracking-tight"
                              >
                                For You
                              </div>
                            </div>
                          </>
                        ) : null}
                        <div className="text-center">
                          <p
                            style={{ lineHeight: 1 }}
                            className={`m-0 pt-2 text-2xl sm:text-3xl font-bold tracking-tight transition-all text-gray-900`}
                          >
                            {planOption?.quantity}
                          </p>
                          <p
                            className={`m-0 font-bold text-xl tracking-tight text-gray-900`}
                          >
                            Meals
                          </p>
                          <p className="text-sm sm:text-base">
                            {coupon ? (
                              <>
                                <span className="text-orange-700">
                                  {getPromotionalPrice(planOption, coupon)} / meal
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="text-gray-900">
                                  {getPrice(planOption)} / meal
                                </span>
                              </>
                            )}
                          </p>
                          {coupon ? (
                            <>
                              <p
                                style={{
                                  textDecoration: "line-through",
                                }}
                                className="mt-0 mb-0 font-weight-500 text-xs sm:text-sm text-gray-900"
                              >
                                <span className="text-gray-700">
                                  {getPrice(planOption)} / meal
                                </span>
                              </p>
                            </>
                          ) : null}

                          <p className={`text-xs sm:text-sm text-gray-700`}>
                            <span>
                              {" "}
                              {getPromotionalPrice(planOption, coupon, false)} total
                            </span>
                          </p>
                        </div>
                        <div
                          className={`transition-all mt-3 flex items-center justify-center ${
                            !planIsSelectable ? "opacity-50" : ""
                          }`}
                        >
                          <span
                            className={`flex h-7 w-7 items-center justify-center rounded-full border-2 ${
                              planIsSelected
                                ? "border-orange-500 bg-orange-500"
                                : "border-orange-500 bg-white"
                            }`}
                          >
                            {planIsSelected ? (
                              <svg
                                className="h-4 w-4 text-white"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.5 8.5L6.5 11.5L12.5 5.5"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            ) : null}
                          </span>
                        </div>
                      </div>
                        );
                      })()}
                    </>
                  ))}
                </div>
                <div className="mt-4 text-center sm:max-w-[620px] sm:mx-auto"></div>
                <div className="my-4 h-[1px] bg-gray-100 rounded"></div>
                <div className="text-center mb-4">
                  <p className="md:text-lg text-gray-900">
                    You'll be able to choose your meal selection from our
                    current menu after you choose your plan 🎉
                  </p>
                </div>
                {allMeals?.map((meal: any, i: any) => (
                  <div key={i} className="shadow-sm mb-3">
                    <MealOptionCardNoSelection
                      position={i + 1}
                      modalID={mealInfoModalID}
                      meal={meal}
                      mobile={true}
                    ></MealOptionCardNoSelection>
                  </div>
                ))}
              </div>
            </>
          ) : null}
          {step == "checkout" ? (
            <div className="">
              <div
                onClick={() => {
                  setShowOrderSummary(true);

                  SegmentUtils.track("Cart Viewed", {
                    cart_id:
                      (lead?.userID ? lead?.userID : lead?._id) +
                      "_cart_" +
                      moment().format("YYYY-MM-DD"),
                    products: [
                      {
                        product_id: plan?._id,
                        quantity: 1,
                        procurement: plan?.procurement,
                        frequency: plan?.frequency,
                        sku: plan?.code,
                        category: "Meal Plans",
                        name: plan?.name,
                        brand: "Project LeanNation",
                        category1: plan?.planType?.name,
                        category2: plan?.procurement,
                        category3: plan?.frequency,
                        price:
                          (plan?.unitPrice +
                            (plan?.deliveryFee ? plan?.deliveryFee : 0)) /
                          100,
                      },
                    ],
                  });
                }}
                className="d-block d-lg-none px-3 py-2 cursor-pointer plan-summary-dropdown shadow-sm"
                style={{
                  background: "white",
                  position: "sticky",
                  top: 0,
                  width: "100%",
                  zIndex: 10,
                  borderBottom: "1px solid var(--midlighter)",
                }}
              >
                <IonRow className="ion-align-items-center">
                  <IonCol size-xs="">
                    <h3
                      className="text-dark mb-0 mt-0 text-capitalize font-weight-bold"
                      style={{ fontSize: 15 }}
                    >
                      PLN+ Plan Summary&nbsp;
                      <span style={{ position: "relative", top: 3 }}>
                        <IonIcon icon={chevronDown}></IonIcon>
                      </span>
                    </h3>
                  </IonCol>
                  <IonCol size-xs="auto">
                    <h1
                      className="text-dark mb-0 mt-0 font-weight-bold"
                      style={{ fontSize: 16 }}
                    >
                      {
                        <>
                          <span
                            className={`${
                              coupon || referral
                                ? "text-orange-600"
                                : "text-dark"
                            }`}
                          >
                            {getPromotionalPrice(plan, coupon, false)}
                          </span>
                          {coupon || referral ? (
                            <>
                              <span
                                className="pl-1 text-medium font-weight-500"
                                style={{
                                  textDecoration: "line-through",
                                }}
                              >
                                {getPrice(plan, null, false)}
                              </span>
                            </>
                          ) : null}
                        </>
                      }
                    </h1>
                  </IonCol>
                </IonRow>
              </div>

              <div className="px-4">
                <div className="my-4">
                  {stripe && stripeOptions ? (
                    <Elements stripe={stripe} options={stripeOptions}>
                      <ElementsConsumer>
                        {({ stripe, elements }) => (
                          <StripeCheckoutForm
                            lead={lead}
                            plan={plan}
                            selectedMeals={selectedMeals}
                            referral={referral}
                            coupon={coupon}
                            stripeCustomerID={stripeCustomerID}
                            embeddedForm={true}
                            onSignupComplete={() => {
                              onSignupComplete();
                            }}
                            email={lead?.email}
                            phone={lead?.phone}
                            stripe={stripe}
                            elements={elements}
                            firstBillDate={getFirstBillingDate(false)}
                            store={store}
                            hideSubmitSection={true}
                            submitTrigger={checkoutSubmitTrigger}
                            confirmSubscriptionTerms={
                              checkoutFooterState.confirmSubscriptionTerms
                            }
                            onConfirmSubscriptionTermsChange={(
                              confirmSubscriptionTerms: boolean,
                            ) => {
                              setCheckoutFooterState((prevState: any) => {
                                if (
                                  prevState.confirmSubscriptionTerms ===
                                  confirmSubscriptionTerms
                                ) {
                                  return prevState;
                                }

                                return {
                                  ...prevState,
                                  confirmSubscriptionTerms,
                                };
                              });
                            }}
                            onCheckoutStateChange={(nextState: any) => {
                              setCheckoutFooterState((prevState: any) => {
                                const mergedState = {
                                  ...prevState,
                                  ...nextState,
                                };

                                const hasChanged = Object.keys(nextState).some(
                                  (key) => prevState[key] !== mergedState[key],
                                );

                                return hasChanged ? mergedState : prevState;
                              });
                            }}
                            onComplete={() => {
                              onSubmitting();
                            }}
                          ></StripeCheckoutForm>
                        )}
                      </ElementsConsumer>
                    </Elements>
                  ) : (
                    <>
                      <IonSkeletonText
                        animated={true}
                        style={{
                          width: "100%",
                          height: 300,
                          borderRadius: 6,
                          marginTop: -4,
                          marginBottom: -4,
                        }}
                      ></IonSkeletonText>
                    </>
                  )}
                </div>
                {checkoutFooterState.requiresSubscriptionTerms ? (
                  <div
                    onClick={() => {
                      setCheckoutFooterState((prevState: any) => ({
                        ...prevState,
                        confirmSubscriptionTerms:
                          !prevState.confirmSubscriptionTerms,
                      }));
                    }}
                    className={`cursor-pointer rounded-md mb-4 -mt-6 p-2 flex gap-x-3 items-center ${
                      checkoutFooterState.confirmSubscriptionTerms
                        ? "bg-orange-50"
                        : "bg-white"
                    } border-[1px] ${
                      checkoutFooterState.confirmSubscriptionTerms
                        ? "border-orange-500"
                        : "border-gray-200"
                    }`}
                  >
                    {checkoutFooterState.confirmSubscriptionTerms ? (
                      <IonIcon
                        className="text-[24px] text-primary"
                        style={{ lineHeight: 1 }}
                        icon={checkmarkCircle}
                      ></IonIcon>
                    ) : (
                      <IonIcon
                        className="text-[24px] text-gray-400"
                        style={{ lineHeight: 1 }}
                        icon={checkmarkCircleOutline}
                      ></IonIcon>
                    )}
                    <div
                      className="text-sm"
                      style={{ maxWidth: "calc(100% - 50px)" }}
                    >
                      I agree to automatic renewal of my PLN+ {plan?.name} Meal
                      Plan unless I choose to skip an order or cancel anytime in
                      the PLN app or online.
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </IonContent>
        {step == "plans" ? (
          <IonFooter color="white" className="ion-no-border border-t border-gray-100" style={{paddingBottom: 'var(--ion-safe-area-bottom)'}}>
            <IonToolbar
              color="white"
              mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
              className="px-3 py-2"
            >
              <IonButton
                expand="block"
                color="primary"
                disabled={!persistedSelectedPlan}
                onClick={continueWithSelectedPlan}
                className="h-[55px]"
              >
                <div className="flex flex-col items-center justify-center leading-tight">
                  <div className="text-base font-bold">
                    {persistedSelectedPlan ? "Continue" : "Select A Plan"}
                  </div>
                  <div className="text-xs text-white">
                    {persistedSelectedPlan
                      ? persistedSelectedPlan?.name
                      : "Choose a plan to continue"}
                  </div>
                </div>
              </IonButton>
            </IonToolbar>
          </IonFooter>
        ) : null}
        {step == "checkout" ? (
          <IonFooter color="white" className="ion-no-border border-t border-gray-100" style={{paddingBottom: 'var(--ion-safe-area-bottom)'}}>
            <IonToolbar
            color="white"
              mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
              className="px-3 py-2 bg-white"
            >
              <IonButton
                color="primary"
                mode={
                  Capacitor.isNativePlatform()
                    ? Capacitor.getPlatform() == "ios"
                      ? "ios"
                      : "md"
                    : "ios"
                }
                expand="block"
                className="h-[50px]"
                disabled={!checkoutFooterState.canSubmit}
                onClick={() => {
                  setCheckoutSubmitTrigger((prevState) => prevState + 1);
                }}
              >
                {checkoutFooterState.submitting ? (
                  <IonSpinner name="dots"></IonSpinner>
                ) : (
                  "Complete Signup"
                )}
              </IonButton>
              <p
                className="text-gray-900 text-center mt-2 mb-1"
                style={{ fontSize: 13, lineHeight: 1.2 }}
              >
                No payment collected today. You'll be charged on&nbsp;
                {checkoutFooterState.firstBillDate
                  ? checkoutFooterState.firstBillDate
                  : getFirstBillingDate(false)}{" "}
                for your first order.
              </p>
            </IonToolbar>
          </IonFooter>
        ) : null}
      </IonModal>
      <IonModal
        mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
        className="modal-mealdetail"
        ref={orderSummaryRef}
        isOpen={showOrderSummary}
      >
        <IonHeader>
          <IonToolbar
            mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
            className={
              Capacitor.isNativePlatform()
                ? "box-modal-toolbar-native"
                : "box-modal-toolbar-web"
            }
            style={{ borderBottom: "none" }}
            color="white"
          >
            <IonTitle>PLN+ Plan Summary</IonTitle>
            <IonButtons slot="start">
              <IonButton onClick={() => setShowOrderSummary(false)}>
                Close
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div style={{}} className="px-3 pt-3">
            <IonRow className="ion-align-items-top">
              <IonCol size-xs="12" className="px-0 pt-0">
                <p
                  className="text-dark text-capitalize mt-0 mb-1 font-weight-500"
                  style={{ fontSize: 13 }}
                >
                  PLN+ Membership:
                </p>
              </IonCol>
              <IonCol size-xs="" className="pl-0 pb-0 py-0">
                <h1
                  className="text-dark mb-0 mt-0 text-capitalize font-[SourceSerif] font-weight-500"
                  style={{ fontSize: 18 }}
                >
                  {
                    <>
                      {plan ? (
                        <>
                          {plan?.quantity} Meals /{" "}
                          {plan?.frequency == "weekly" ? "Week" : "2 Weeks"}
                        </>
                      ) : (
                        <>--</>
                      )}
                    </>
                  }
                </h1>
                <p
                  className="text-dark text-capitalize mt-1 mb-0 font-weight-500"
                  style={{ fontSize: 13 }}
                >
                  {plan ? (
                    <>
                      {plan?.planType?.name?.trim()}
                      &nbsp;Meal Plan
                    </>
                  ) : (
                    "Loading Plan..."
                  )}
                </p>
              </IonCol>
              <IonCol className="pr-0 py-0 text-right">
                <h1
                  className="text-dark mb-0 mt-0 font-weight-bold"
                  style={{ fontSize: 17 }}
                >
                  {
                    <>
                      <span
                        className={`${
                          coupon || referral ? "text-orange-600" : "text-dark"
                        }`}
                      >
                        {getPromotionalPrice(plan, coupon, false)}
                      </span>
                      {coupon || referral ? (
                        <>
                          <span
                            className="pl-1 text-medium font-weight-500"
                            style={{
                              textDecoration: "line-through",
                            }}
                          >
                            {getPrice(plan, null)}
                          </span>
                        </>
                      ) : null}
                    </>
                  }
                </h1>
                {(coupon && coupon?.removeFromSubscriptionAfterUses !== -1) ||
                referral ? (
                  <p
                    className="text-medium text-lowercase text-right mt-1 mb-0 font-weight-500"
                    style={{ fontSize: 13 }}
                  >
                    {getPrice(plan, null)} after discounts
                  </p>
                ) : null}
              </IonCol>
            </IonRow>
          </div>
          <div
            style={{
              borderBottom: "1px solid var(--midlighter)",
            }}
            className="p-3"
          >
            <IonRow className="ion-align-items-top">
              <IonCol size-xs="" className="pl-0 pb-0 py-0">
                <h1
                  className="text-dark mb-0 mt-0 text-capitalize font-weight-bold"
                  style={{ fontSize: 16 }}
                >
                  Due Today:
                </h1>
              </IonCol>
              <IonCol className="pr-0 py-0 text-right">
                <h1
                  className="text-dark mb-0 mt-0 font-weight-bold"
                  style={{ fontSize: 16 }}
                >
                  $0.00
                </h1>
              </IonCol>
            </IonRow>
          </div>
          <div
            style={{
              borderBottom: "1px solid var(--midlighter)",
            }}
            className="p-3"
          >
            <IonRow className="ion-align-items-center">
              <IonCol size-xs="" className="pl-0 pb-0 py-0">
                <p
                  className="text-dark text-capitalize mt-0 mb-1 font-weight-500"
                  style={{ fontSize: 13 }}
                >
                  {plan ? (
                    <span className="text-capitalize">
                      First{" "}
                      {plan?.procurement
                        ?.trim()
                        ?.replace("shipping", "shipment")}{" "}
                      {plan?.procurement?.trim() == "pickup" ? "@" : "from"}{" "}
                      {store?.name?.replace("Project LeanNation", "PLN").trim()}
                      :
                    </span>
                  ) : (
                    <>First Order Ready:</>
                  )}
                </p>
                <p
                  style={{ fontSize: 18 }}
                  className="text-dark m-0 font-[SourceSerif] font-weight-500"
                >
                  {<>{getFirstBillingDate(false)}</>}
                </p>
              </IonCol>
            </IonRow>
          </div>
          <div
            style={{
              borderBottom: "1px solid var(--midlighter)",
            }}
            className="p-3"
          >
            <IonRow className="ion-align-items-center">
              <IonCol size-xs="12" className="pl-0 pb-0 py-0">
                <p
                  className="text-dark text-capitalize mt-0 mb-1 font-weight-500"
                  style={{ fontSize: 13 }}
                >
                  {coupon ? <>Discount Applied</> : <>Discount</>}
                </p>
              </IonCol>
              <IonCol size-xs="12" className="px-0 py-0">
                {coupon ? (
                  <>
                    <div
                      className="p-2 mt-2"
                      style={{
                        border: "1px solid var(--midlighter)",
                        background: "var(--ultralight)",
                        borderRadius: 6,
                      }}
                    >
                      <IonRow className="ion-align-items-center">
                        <IonCol size-xs="" className="pl-0 py-0">
                          <p
                            className="text-dark font-weight-bold text-uppercase m-0"
                            style={{ fontSize: 16 }}
                          >
                            {coupon?.code}
                          </p>
                          <p
                            className="text-dark font-weight-normal m-0"
                            style={{ fontSize: 12 }}
                          >
                            {StringUtils.generateCouponValueString(
                              coupon,
                              true,
                            )}
                          </p>
                        </IonCol>
                        <IonCol size-xs="auto" className="pr-0 py-0">
                          <IonButton
                            color="danger"
                            fill="clear"
                            size="small"
                            className="pln-button-web-link"
                            onClick={() => {
                              setCoupon(null);

                              StorageUtils.set("checkout_coupon", null);
                              PubSub.publish(
                                Event.CHECKOUT.COUPON_UPDATED,
                                null,
                              );
                            }}
                          >
                            <IonIcon slot="icon-only" icon={close} />
                          </IonButton>
                        </IonCol>
                      </IonRow>
                    </div>
                  </>
                ) : (
                  <>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();

                        if (!couponCode) {
                          return;
                        }

                        loadCoupon(couponCode);
                      }}
                    >
                      <IonRow className="ion-align-items-center mt-2">
                        <IonCol size-xs="" className="pl-0 py-0">
                          <IonInput
                            mode="ios"
                            className="border rounded px-2"
                            autocapitalize="none"
                            inputMode="text"
                            color="dark"
                            name="couponCode"
                            value={couponCode}
                            //pattern="email"
                            placeholder="Discount Code"
                            onIonInput={(event: any) => {
                              setCouponCode(event?.detail?.value);
                            }}
                          ></IonInput>
                        </IonCol>
                        <IonCol size-xs="auto" className="pr-0 py-0">
                          <IonButton
                            className="pln-button-web-link h-[46px] w-[46px] ion-button-text-white"
                            disabled={couponSubmitting || !couponCode}
                            onClick={(e) => {
                              e.preventDefault();

                              loadCoupon(couponCode);
                            }}
                          >
                            {couponSubmitting ? (
                              <IonSpinner name="dots"></IonSpinner>
                            ) : (
                              <IonIcon slot="icon-only" icon={arrowForward} />
                            )}
                          </IonButton>
                        </IonCol>
                        {couponError ? (
                          <IonCol size-xs="12" className="px-0 pt-1 pb-0">
                            <div
                              className="font-weight-500"
                              style={{
                                color: "var(--danger)",
                                fontSize: 14,
                              }}
                            >
                              {couponError}
                            </div>
                          </IonCol>
                        ) : null}
                      </IonRow>
                    </form>
                  </>
                )}
              </IonCol>
            </IonRow>
          </div>
          <div
            style={{
              borderBottom: "1px solid var(--midlighter)",
            }}
            className="p-3"
          >
            <IonRow className="ion-align-items-center">
              <IonCol size-xs="12" className="pl-0 pb-0 py-0">
                <p
                  className="text-dark text-capitalize mt-0 mb-1 font-weight-500"
                  style={{ fontSize: 13 }}
                >
                  {referral ? (
                    <>Referral Applied:</>
                  ) : (
                    <>Referred By A Friend? Enter Their Referral Code:</>
                  )}
                </p>
              </IonCol>
              <IonCol size-xs="12" className="px-0 py-0">
                {referral ? (
                  <>
                    <div
                      className="p-2 mt-2"
                      style={{
                        border: "1px solid var(--midlighter)",
                        background: "var(--ultralight)",
                        borderRadius: 6,
                      }}
                    >
                      <IonRow className="ion-align-items-center">
                        <IonCol size-xs="" className="pl-0 py-0">
                          <p
                            className="text-dark font-weight-bold text-uppercase m-0"
                            style={{ fontSize: 16 }}
                          >
                            {referral?.name}
                          </p>
                          <p
                            className="text-dark font-weight-normal m-0"
                            style={{ fontSize: 12 }}
                          >
                            {StringUtils.generateCouponValueString(
                              referral,
                              true,
                            )}
                          </p>
                        </IonCol>
                        <IonCol size-xs="auto" className="pr-0 py-0">
                          <IonButton
                            color="danger"
                            fill="clear"
                            size="small"
                            className="pln-button-web-link"
                            onClick={() => {
                              setReferral(null);

                              StorageUtils.set("checkout_referral", null);
                            }}
                          >
                            <IonIcon slot="icon-only" icon={close} />
                          </IonButton>
                        </IonCol>
                      </IonRow>
                    </div>
                  </>
                ) : (
                  <>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();

                        if (!referralCode) {
                          return;
                        }

                        loadReferral(referralCode);
                      }}
                    >
                      <IonRow className="ion-align-items-center mt-2">
                        <IonCol size-xs="" className="pl-0 py-0">
                          <IonInput
                            mode="ios"
                            autocapitalize="none"
                            inputMode="text"
                            color="dark"
                            name="referralCode"
                            value={referralCode}
                            //pattern="email"
                            placeholder="M-XXXXXX"
                            className="border rounded px-2"
                            onIonInput={(event: any) => {
                              setReferralCode(event?.detail?.value);
                            }}
                          ></IonInput>
                        </IonCol>
                        <IonCol size-xs="auto" className="pr-0 py-0">
                          <IonButton
                            className="pln-button-web-link h-[46px] w-[46px] ion-button-text-white"
                            disabled={referralSubmitting || !referralCode}
                            onClick={(e) => {
                              e.preventDefault();

                              loadReferral(referralCode);
                            }}
                          >
                            {referralSubmitting ? (
                              <IonSpinner name="dots"></IonSpinner>
                            ) : (
                              <IonIcon slot="icon-only" icon={arrowForward} />
                            )}
                          </IonButton>
                        </IonCol>
                        {referralError ? (
                          <IonCol size-xs="12" className="px-0 pt-1 pb-0">
                            <div
                              className="font-weight-500"
                              style={{
                                color: "var(--danger)",
                                fontSize: 14,
                              }}
                            >
                              {referralError}
                            </div>
                          </IonCol>
                        ) : null}
                      </IonRow>
                    </form>
                  </>
                )}
              </IonCol>
            </IonRow>
          </div>
          <div style={{}} className="px-3 pt-3 pb-1">
            <IonRow className="ion-align-items-center">
              <IonCol size-xs="12" className="pl-0 pb-0 py-0">
                <h1
                  className="text-dark mb-1 mt-0 text-capitalize font-[SourceSerif] font-weight-500"
                  style={{ fontSize: 18 }}
                >
                  Meals On{" "}
                  {store
                    ? `The ${store?.name
                        ?.replace("Project LeanNation", "PLN")
                        ?.trim()}`
                    : "Our"}{" "}
                  Menu:
                </h1>
                <p
                  className="text-dark text-base mt-1 mb-0"
                  style={{ lineHeight: 1.5 }}
                >
                  You can choose from any of these meals for your first order
                  after you finish signing up.
                </p>
              </IonCol>
            </IonRow>
          </div>
          <div>
            {allMeals?.length ? (
              <>
                {allMeals?.map((meal: any, i: number) => (
                  <div key={meal?._id}>
                    <div
                      className="mx-3 my-3"
                      style={{
                        borderRadius: 6,
                        overflow: "hidden",
                        border: "1px solid var(--lighter)",
                      }}
                    >
                      <MealOptionCardNoSelection
                        meal={meal}
                        mobile={true}
                        compact={true}
                        modalID="webapp-checkout-box"
                      ></MealOptionCardNoSelection>
                    </div>
                    {i == allMeals?.length - 1 && (
                      <>
                        <div className="pb-4" />
                      </>
                    )}
                  </div>
                ))}
              </>
            ) : (
              <>
                <div
                  className="border mt-3 mb-3 mx-3 p-3 text-center d-flex ion-align-items-center"
                  style={{
                    borderRadius: 6,
                    height: "calc(100% - 2rem)",
                  }}
                >
                  <div>
                    <h1
                      style={{ fontSize: 18 }}
                      className="text-dark mb-2 font-weight-500"
                    >
                      Loading Your Menu
                    </h1>
                    <p className="m-0 text-dark">
                      Hang tight while we're loading your menu.
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </IonContent>
      </IonModal>
    </>
  );
};

export default PLNPlusUpsellModal;
